import type { ReactNode } from "react";

/** Compact review: decisions beside the assessment, optional references beneath it. */
export function ReviewCardLayout({
  children,
  references,
  actions,
}: {
  readonly children: ReactNode;
  readonly references: ReactNode;
  readonly actions: ReactNode;
}) {
  return (
    <div
      data-review-layout
      className="relative grid min-w-0 grid-cols-1 gap-x-5 gap-y-3.5 min-[901px]:grid-cols-[minmax(0,1fr)_auto]"
    >
      <div data-review-content className="min-w-0 min-[901px]:col-start-1 min-[901px]:row-start-1">
        {children}
      </div>
      <div data-review-rail className="contents">
        {references === null || references === undefined ? null : (
          <div
            data-review-references
            className="col-span-full flex min-w-0 flex-col gap-3 py-2 min-[901px]:flex-row min-[901px]:flex-wrap min-[901px]:gap-x-6 min-[901px]:gap-y-2 min-[901px]:py-0"
          >
            {references}
          </div>
        )}
        <div
          data-review-actions
          className="pointer-events-auto relative z-10 flex flex-wrap items-center gap-1.5 self-start min-[901px]:col-start-2 min-[901px]:row-start-1"
        >
          {actions}
        </div>
      </div>
    </div>
  );
}
